import { FormikProps, getIn } from 'formik';
import { type GetFieldInputOutput } from './getFieldInputProps.d';

export const getFieldInputProps = <
	S extends FormikProps<{
		// eslint-disable-next-line
		[key in keyof S['values']]: any;
	}>,
>(
	formik: S,
	name: keyof S['values'],
	option?: {
		regex?: RegExp;
	}
): GetFieldInputOutput => {
	const { values, touched, errors, setValues, setFieldError } = formik;
	const { regex } = option || {};

	const onChange = (value: string) => {
		setFieldError(String(name),'')
		if (value && regex && !regex.test(value)) return;
		setValues((prevValue) => ({
			...prevValue,
			[name]: value,
		}));
	};

	return {
		id: name as string,
		name: name as string,
		onChange: onChange,
		value: getIn(values, String(name)) || '',
		touched: getIn(touched, String(name)),
		error: getIn(touched, String(name)) ? getIn(errors, String(name)) : ''
	};
};
